import { render, staticRenderFns } from "./TestimonialsForm.vue?vue&type=template&id=785c60e3"
import script from "./TestimonialsForm.vue?vue&type=script&lang=js"
export * from "./TestimonialsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports